import { ShieldCheck } from "lucide-react";
import { Reveal } from "../ui/Reveal";
import { Parallax } from "../ui/Parallax";
import { Wave } from "../ui/decor";

export function Science() {
  return (
    <section id="science" className="relative overflow-hidden bg-navy">
      {/* Melt into the cream page above and below */}
      <Wave fill="#FFF6EC" flip />

      <div className="container-x py-16 sm:py-24">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          {/* Copy — one honest number, plain language */}
          <div className="text-center lg:text-left">
            <Reveal>
              <span className="sticker -rotate-2 !shadow-pop-white">The honest bit</span>
            </Reveal>
            <Reveal delay={1}>
              <h2 className="display mt-6 text-4xl leading-[1.06] text-white sm:text-5xl lg:text-6xl">
                Built on a real number,
                <span className="block text-teal-light">not game points.</span>
              </h2>
            </Reveal>
            <Reveal delay={2}>
              <p className="mx-auto mt-6 max-w-lg text-base leading-relaxed text-white/75 sm:text-lg lg:mx-0">
                A kilogram of body fat stores roughly{" "}
                <span className="font-semibold text-sun">7,700 calories</span>.
                That physical fact is what your bank is grounded in — no arbitrary
                points, no black box. Tap any earning in the app and you'll see the
                exact maths with your own numbers in it.
              </p>
            </Reveal>

            <Reveal delay={3}>
              <div className="mt-8 inline-flex rotate-1 items-center gap-3 rounded-2xl border-[3px] border-white/90 bg-navy-800 px-5 py-4 text-left shadow-pop-white">
                <ShieldCheck className="h-5 w-5 shrink-0 text-teal-light" aria-hidden />
                <p className="text-sm font-bold text-white/85">
                  Transparent by design. Nothing is hidden from you.
                </p>
              </div>
            </Reveal>
          </div>

          {/* Photo with the anchor number over it */}
          <Reveal delay={1}>
            <Parallax distance={40}>
              <div className="relative rotate-2 overflow-hidden rounded-[2rem] border-4 border-white shadow-pop-sun">
                <img
                  src="/photos/science-food.jpg"
                  alt="Fresh, whole foods laid out — real calories, real fuel"
                  className="aspect-[4/3] h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-950/85 via-navy-950/20 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-6 text-center sm:p-8">
                  <p className="display text-7xl text-sun sm:text-8xl">7,700</p>
                  <p className="mt-1 font-mono text-xs uppercase tracking-[0.2em] text-white/80">
                    calories stored in a kilogram of fat
                  </p>
                </div>
              </div>
            </Parallax>
          </Reveal>
        </div>
      </div>

      <Wave fill="#FFF6EC" />
    </section>
  );
}
